import { createTheme } from '@mui/material/styles';

/**
 * UVD Theme — MUI theme aligned with existing CSS design system.
 * Colors match DESIGN.md palette: primary orange, secondary blue, ink navy.
 */
const uvdTheme = createTheme({
  palette: {
    primary: {
      main: '#E84721',
      light: '#FF6B4A',
      dark: '#C2381A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#40AFED',
      light: '#6FC5F1',
      dark: '#2A8FCC',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FAFAF7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A2332',
      secondary: '#64748B',
    },
    error: { main: '#EF4444' },
    warning: { main: '#F59E0B' },
    success: { main: '#10B981' },
    info: { main: '#40AFED' },
  },
  typography: {
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontWeight: 700,
      fontSize: '2.75rem',
      lineHeight: 1.25,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.35,
    },
    h5: {
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 600,
      fontSize: '1.1rem',
      lineHeight: 1.4,
    },
    button: {
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 600,
      textTransform: 'none' as const,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '10px 24px',
          transition: 'all 0.2s cubic-bezier(0, 0, 0.2, 1)',
        },
        contained: {
          '&.MuiButton-colorPrimary': {
            boxShadow: '0 4px 14px 0 rgba(232, 71, 33, 0.35)',
            '&:hover': {
              boxShadow: '0 6px 20px 0 rgba(232, 71, 33, 0.45)',
              transform: 'translateY(-2px)',
            },
          },
          '&.MuiButton-colorSecondary': {
            boxShadow: '0 4px 14px 0 rgba(64, 175, 237, 0.35)',
            '&:hover': {
              boxShadow: '0 6px 20px 0 rgba(64, 175, 237, 0.45)',
              transform: 'translateY(-2px)',
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          transition: 'all 0.3s cubic-bezier(0, 0, 0.2, 1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          backgroundImage: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: "'DM Sans', sans-serif",
          fontWeight: 600,
          letterSpacing: '0.04em',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(26, 35, 50, 0.85)',
        },
      },
    },
  },
});

export default uvdTheme;
